import { CommitmentsVersionsService_commitmentVersionsServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentsVersionsService_commitmentVersionsServiceGetEntity'

export const useFetchCommitmentVersionNoSuspense =
  CommitmentsVersionsService_commitmentVersionsServiceGetEntity.useQuery
